import i18n from '@/libs/i18n'

export default [
  // *===============================================---*
  // *--------- SUGGESTION ---------------------------*
  // *===============================================---*
  {
    path: '/suggestions/list',
    name: 'pages-suggestions-list',
    component: () => import('@/views/pages/suggestion/SuggestionList.vue'),
    meta: {
      action: 'read',
      resource: 'suggestions',
      required: true,
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('suggestions.mainVerticalMenu.suggestions'),
    },
  },
  {
    path: '/suggestions/archive',
    name: 'pages-suggestions-archive',
    component: () => import('@/views/pages/suggestion/SuggestionArchive.vue'),
    meta: {
      action: 'read',
      resource: 'suggestions',
      required: true,
      breadcrumb: [
        {
          text: i18n.t('suggestions.suggestionsArchive'),
          active: false,
        },
      ],
      pageTitle: i18n.t('suggestions.mainVerticalMenu.suggestions'),
    },
  },
  {
    path: '/suggestions/edit/:id',
    name: 'pages-suggestions-edit',
    component: () => import('@/views/pages/suggestion/SuggestionEdit.vue'),
    meta: {
      action: 'update',
      resource: 'suggestions',
      required: true,
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
          active: false,
        },
      ],
      pageTitle: i18n.t('suggestions.mainVerticalMenu.suggestions'),
    },

  },
]
